import { observer } from 'mobx-react-lite';
import { useSearchParams } from 'react-router-dom';

import ProductPropertyFilter from '~/components/ProductPropertyFilter/ProductPropertyFilter';
import { useProductChoices } from '~/hooks/useProductChoices';
import { Offer, ProductState } from '~/stores/CategoriesStore';

import styles from './ProductFilters.module.scss';

interface ProductFiltersProps {
  productData: ProductState;
  selectedOffer: Offer;
  isBundle: boolean;
  selectOffer: (sku: string) => void;
}

const ProductFilters = observer(
  ({
    selectedOffer,
    isBundle,
    productData,
    selectOffer,
  }: ProductFiltersProps) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const currentProductFilters = useProductChoices({ product: productData });

    const handleChangeOffer = (sku: string) => () => {
      selectOffer(sku);
      searchParams.set('sku', sku);
      setSearchParams(searchParams, { replace: true });
    };
    if (!selectedOffer || isBundle) {
      return null;
    }

    return (
      <div className={styles.volume}>
        <div className={styles.filtersContainer}>
          {Object.values(currentProductFilters)
            .sort((a, b) => a.sorting - b.sorting || a.order - b.order)
            .map((filter, idx) => (
              <ProductPropertyFilter
                filter={filter}
                handleChangeOffer={handleChangeOffer}
                key={idx}
                name="desk"
                withTitle={false}
                classes={{
                  filterListContainerClassName: styles.filterListContainer,
                  filterListClassName: styles.filterList,
                  filterItemClassName:
                    filter.type === 'colorList'
                      ? styles.filterItemColor
                      : styles.filterItem,
                }}
              />
            ))}
        </div>
      </div>
    );
  },
);

export default ProductFilters;
